var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDatabase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 3.75C15.375 4.99264 12.3529 6 8.625 6C4.89708 6 1.875 4.99264 1.875 3.75C1.875 2.50736 4.89708 1.5 8.625 1.5C12.3529 1.5 15.375 2.50736 15.375 3.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 6.975V3.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.75V14.25C1.87453 14.7365 2.34714 15.21 3.222 15.5994C4.09686 15.9888 5.32682 16.2732 6.7275 16.41",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_57_421)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stroke0_57_421",
    maskUnits: "userSpaceOnUse",
    x: 8.125,
    y: 7.82489,
    width: 10,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.125,
    y: 7.82489,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8772 11.2686C16.0358 11.11 16.1249 10.8949 16.1249 10.6707C16.125 10.4464 16.0359 10.2313 15.8773 10.0727C15.7188 9.91404 15.5037 9.82492 15.2794 9.82489C15.0551 9.82486 14.84 9.91393 14.6814 10.0725L10.6776 14.0772C10.6079 14.1467 10.5564 14.2322 10.5276 14.3262L10.1313 15.6318C10.1235 15.6577 10.1229 15.6853 10.1296 15.7116C10.1362 15.7378 10.1499 15.7618 10.169 15.7809C10.1882 15.8 10.2122 15.8136 10.2384 15.8202C10.2647 15.8268 10.2922 15.8262 10.3182 15.8184L11.6241 15.4224C11.718 15.3938 11.8035 15.3426 11.8731 15.2733L15.8772 11.2686Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8772 11.2686C16.0358 11.11 16.1249 10.8949 16.1249 10.6707C16.125 10.4464 16.0359 10.2313 15.8773 10.0727C15.7188 9.91404 15.5037 9.82492 15.2794 9.82489C15.0551 9.82486 14.84 9.91393 14.6814 10.0725L10.6776 14.0772C10.6079 14.1467 10.5564 14.2322 10.5276 14.3262L10.1313 15.6318C10.1235 15.6577 10.1229 15.6853 10.1296 15.7116C10.1362 15.7378 10.1499 15.7618 10.169 15.7809C10.1882 15.8 10.2122 15.8136 10.2384 15.8202C10.2647 15.8268 10.2922 15.8262 10.3182 15.8184L11.6241 15.4224C11.718 15.3938 11.8035 15.3426 11.8731 15.2733L15.8772 11.2686Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000",
    mask: "url(#stroke0_57_421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 10.725L15.2254 11.925",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 9C1.87608 9.35065 2.12302 9.69636 2.59609 10.0095C3.06917 10.3227 3.75529 10.5947 4.59972 10.8038C5.44415 11.0129 6.42351 11.1534 7.45966 11.2139C7.84567 11.2364 8.23558 11.2477 8.625 11.2477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_57_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.2,
    fill: "white",
    transform: "translate(8.09961 8.02502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDatabase);
export default __webpack_public_path__ + "static/media/EditDatabase.39552d2180422caee106ee1ce857e763.svg";
export { ForwardRef as ReactComponent };